import { render, staticRenderFns } from "./DonutChart23.vue?vue&type=template&id=503dc8c1&scoped=true"
import script from "./DonutChart23.vue?vue&type=script&lang=js"
export * from "./DonutChart23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503dc8c1",
  null
  
)

export default component.exports